import React from 'react';
import PropTypes from 'prop-types';

export default function Row({ className, style, first, last, children }) {
    const classNames = ['grid-row'];
    if (className) {
        classNames.push(className);
    }

    if (first) {
        classNames.push('first');
    }

    if (last) {
        classNames.push('last');
    }

    return (
        <div className={classNames.join(' ')} style={style}>
            {children}
        </div>
    );
}

Row.propTypes = {
    className: PropTypes.string,
    style: PropTypes.string,
    first: PropTypes.string,
    last: PropTypes.string,
    children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/Row.js